import { ScrollPositionRestorationConfig } from './scroll-position-restoration-config';

export const defaultScrollPositionRestorationConfig: ScrollPositionRestorationConfig = {
  pollDuration: 3000,
  pollCadence: 50,
  debug: false,
};
